import dot from 'dot-object'

import { _userParser } from '~/entities/user/user/api/parser-users'

import type { IAnswer, IComment } from '~/features-swym/comment/interfaces/comment'
import type {
  CommentResponse,
  ICommentsResponse,
  ICommentsResponseParsed,
  IEditAnswerResponse,
} from '~/features-swym/comment/interfaces/swym-comments'

import { dateParser } from '~/features-shared/content/api/parser-contents'

import type { SwymResponse } from '~/interfaces/services-dto'

const MOVE_PROPS = [
  // 3DComment
  ['subjectUri', 'content_uri'],
  ['commentUri', 'subject_uri'],
  ['nbEndorses', 'nb_endorses'],
  ['nbReplies', 'nb_replies'],
  ['creationDate', 'created_at'],
  ['modificationDate', 'modified_at'],
  ['currentUserEndorse', 'current_user_endorse'],
  ['forwardedFrom', 'forwarded_from'],
  ['accessState', 'access_state'],
  ['moderationState', 'moderation_state'],
  ['parentCommentUri', 'parent_comment_uri'],
  ['richMessage', 'description'],
  // iQuestion answers
  ['NbRatings', 'nb_endorses'],
  ['answer', 'description'],
  ['crdate', 'created_at'],
  ['pubdate', 'published_at'],
  ['moderation_date', 'moderated_at'],
  ['subject6wuri', 'subject_uri'],
]

function isAnswer(comment: IComment | IAnswer): comment is IAnswer {
  return comment.subject_uri.split(':')
    .slice(-2, -1)[0] === 'qnaanswer'
}

export function commentParser(comment: CommentResponse): IComment {
  MOVE_PROPS.forEach(([from, to]) => {
    dot.move(
      from,
      to,
      comment,
    )
  })

  const _comment = comment as unknown as IComment

  // @ts-expect-error ignore type error
  ['created_at', 'published_at', 'moderated_at'].forEach(el => _comment[el] = dateParser(_comment[el]))

  if (isAnswer(_comment)) {
    // @ts-expect-error ignore type error since this comment is an answer
    _comment.current_user_endorse = _comment.my_rate === '1'
    // @ts-expect-error ignore type error since this comment is an answer
    _comment.nb_endorses = Number.parseInt(_comment.nb_endorses)
    // @ts-expect-error ignore type error since this comment is an answer
    _comment.is_validated = _comment.validate === '1'
  }

  return {
    ..._comment,
    author: _userParser(comment.author),
  }
}

export function answerParser(answer: IEditAnswerResponse): Partial<IAnswer> {
  MOVE_PROPS.forEach(([from, to]) => {
    dot.move(
      from,
      to,
      answer,
    )
  })

  return {
    ...answer,
    author: _userParser(answer.author),
  }
}

export function commentsParser(comments: CommentResponse[]): IComment[] {
  return (comments || []).map(el => commentParser(el))
}

export function commentsResponseParser(response: SwymResponse<ICommentsResponse> & {
  hasModerationRight?: boolean
}): SwymResponse<ICommentsResponseParsed> & {
  hasModerationRight?: boolean
} {
  return {
    ...response,
    result: {
      ...response.result,
      comments: commentsParser(response.result.comments),
    },
  }
}
